<template>
    <div class="content">
        <div id="project-area-bar" ref="IndustryBar"></div>
    </div>
</template>

<script>
    import options from './../../../../utils/options'
    import echarts from 'echarts'
    import {getIndustryData} from "../../../../network/projectAnalysis"


    export default {
        name: "Industryv2",
        props: ['IndustryData', 'selectArea', 'selectTime', 'selectType'],

        data() {
            return {
                chartBar: '',
                optionBar: options.optionIndustryBar,
                dataInfo: [],
                legendSelectType: '全部'
            }
        },

        computed: {
            select() {
                return {'地区选择': this.selectArea, '时间选择': this.selectTime, '行业选择': this.selectType}
            }
        },

        methods: {
            chartInit() {
                this.chartBar = echarts.init(this.$refs.IndustryBar);
                this.chartBar.showLoading();
            },
            chartLoading() {
                this.optionBar.xAxis[0].data = this.dataInfo.xAxis_all;
                this.optionBar.series[0].data = this.dataInfo.yAxis_all;
                this.optionBar.series[1].data = this.dataInfo.yAxis_biao;
                this.optionBar.series[2].data = this.dataInfo.yAxis_shu;
                this.optionBar.series[0].markLine.data[0].yAxis = this.dataInfo.average_all;
                this.optionBar.series[1].markLine.data[0].yAxis = this.dataInfo.average_biao;
                this.optionBar.series[2].markLine.data[0].yAxis = this.dataInfo.average_shu;
                if (this.dataInfo.xAxis_all.length < 16) {
                    this.optionBar.dataZoom[0].end = '100'
                } else {
                    this.optionBar.dataZoom[0].end = '40'
                }
                this.optionBar.series[3].data = this.dataInfo.pie_all;
                if (!this.dataInfo.average_all) {
                    this.optionBar.series[3].data = [];
                }

                this.chartBar.hideLoading();
                this.chartBar.setOption(this.optionBar, true);
                this.chartBar.on('click', this.chartClick);
                this.chartBar.on('legendselectchanged', this.legendSelect)
            },

            chartClick(params) {
                if (params.seriesType === 'bar' && this.selectType === '全部行业'){
                    this.chartBar.showLoading();
                    getIndustryData(this.selectArea, this.selectTime, params.name).then(res => {
                        let IndustryData = this.formatDate(res.data.result);
                        this.chartBar.hideLoading();
                        if (this.legendSelectType === '全部') {
                            this.optionBar.series[3].data = IndustryData.pie_all;
                            if (!this.dataInfo.average_all) {
                                this.optionBar.series[3].data = [];
                            }
                        } else if (this.legendSelectType === '报告书') {
                            this.optionBar.series[3].data = IndustryData.pie_shu;
                            if (!this.dataInfo.average_shu) {
                                this.optionBar.series[3].data = [];
                            }
                        }else {
                            this.optionBar.series[3].data = IndustryData.pie_biao;
                            if (!this.dataInfo.average_biao) {
                                this.optionBar.series[3].data = [];
                            }
                        }
                        this.chartBar.setOption(this.optionBar, true)
                    })
                }
            },

            legendSelect(params){
                if (params.selected['全部']) {
                    this.legendSelectType = '全部';
                    this.optionBar.xAxis[0].data = this.dataInfo.xAxis_all;
                    this.optionBar.series[3].data = this.dataInfo.pie_all;
                    if (!this.dataInfo.average_all) {
                        this.optionBar.series[3].data = [];
                    }
                    this.optionBar.legend.selected = {'全部': true, '报告书': false, '报告表': false}
                }else if (params.selected['报告书']) {
                    this.legendSelectType = '报告书';
                    this.optionBar.xAxis[0].data = this.dataInfo.xAxis_shu;
                    this.optionBar.series[3].data = this.dataInfo.pie_shu;
                    if (!this.dataInfo.average_shu) {
                        this.optionBar.series[3].data = [];
                    }
                    this.optionBar.legend.selected = {'全部': false, '报告书': true, '报告表': false}
                }else if (params.selected['报告表']) {
                    this.legendSelectType = '报告表';
                    this.optionBar.xAxis[0].data = this.dataInfo.xAxis_biao;
                    this.optionBar.series[3].data = this.dataInfo.pie_biao;
                    if (!this.dataInfo.average_biao) {
                        this.optionBar.series[3].data = [];
                    }
                    this.optionBar.legend.selected = {'全部': false, '报告书': false, '报告表': true}
                }
                this.chartBar.setOption(this.optionBar, true);
            },
            formatDate(val) {

                let xAxis_all = [];
                let xAxis_biao = [];
                let xAxis_shu = [];

                let yAxis_all = [];
                let yAxis_biao = [];
                let yAxis_shu = [];

                let pie_all = [];
                let pie_biao = [];
                let pie_shu = [];

                for (let value of val['报告表']) {
                    yAxis_biao.push(value)
                }

                for (let i in val['报告书']) {
                    yAxis_shu.push(val['报告书'][i]);
                    yAxis_all.push({'name': val['报告书'][i].name, 'value': val['报告书'][i].value + val['报告表'][i].value})
                }

                yAxis_all.sort((a, b) => b.value - a.value);
                yAxis_biao.sort((a, b) => b.value - a.value);
                yAxis_shu.sort((a, b) => b.value - a.value);

                let anotherCountAll = 0, anotherCountBiao = 0, anotherCountShu = 0;
                for (let i in yAxis_all) {
                    if (i % 2 !== 0) {
                        xAxis_all.push('\n\n' + yAxis_all[i].name);
                        xAxis_biao.push('\n\n' + yAxis_biao[i].name);
                        xAxis_shu.push('\n\n' + yAxis_shu[i].name)
                    }else {
                        xAxis_all.push(yAxis_all[i].name);
                        xAxis_biao.push(yAxis_biao[i].name);
                        xAxis_shu.push(yAxis_shu[i].name)
                    }
                    if (i < 25){
                        pie_all.push(yAxis_all[i]);
                        pie_biao.push(yAxis_biao[i]);
                        pie_shu.push(yAxis_shu[i])
                    }else {
                        anotherCountAll += yAxis_all[i].value;
                        anotherCountBiao += yAxis_biao[i].value;
                        anotherCountShu += yAxis_shu[i].value
                    }
                }
                if (anotherCountAll > 0) {
                    pie_all.push({'name': '其他行业', 'value': anotherCountAll});
                }
                if (anotherCountBiao > 0) {
                    pie_biao.push({'name': '其他行业', 'value': anotherCountBiao});
                }
                if (anotherCountShu > 0) {
                    pie_biao.push({'name': '其他行业', 'value': anotherCountShu});
                }

                function average(yAxis_list) {
                    let count = 0;
                    for (let i of yAxis_list) {
                        count += i.value
                    }
                    return (count/(yAxis_list.length)).toFixed(1)
                }

                let average_all = average(yAxis_all);
                let average_biao = average(yAxis_biao);
                let average_shu = average(yAxis_shu);

                return {
                    xAxis_all, xAxis_biao, xAxis_shu,
                    yAxis_all, yAxis_biao, yAxis_shu,
                    average_all, average_biao, average_shu,
                    pie_all, pie_biao, pie_shu
                }
            },
        },

        watch: {
            select() {
                this.chartBar.showLoading();
            },
            IndustryData: {
                handler(val){
                    this.dataInfo = this.formatDate(val);
                    this.chartLoading()
                },
                deep: true,
            },

        },

        mounted() {
            this.chartInit()
        }
    }

</script>

<style scoped>
    #project-area-bar {
        width: 100%;
        height: 90vh;
        float: left;
        /*margin-right: 30px;*/
        /*margin-top: 30px;*/
         padding-top: 120px;
        /*background-color: #f7f7f7;*/
    }
     .content {

        height: 100vh;
        width: 1640px;
        /*background-color: #71a4d1;*/
        /*display: block;*/
    }
</style>